<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col>
          <h1 class="mt-n5">{{ $t('Deliveries')}}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-flex shrink>
          <v-select class="ml-3 mr-4" :items="facilitiesDisplay" v-model="facilityDisplay" @change="facilityChanged" :label="$t('Facility')"></v-select>
        </v-flex>
          <v-menu
            ref="menuFrom"
            v-model="menuFrom"
            :return-value.sync="filters.DateFrom"
            transition="scale-transition"
            offset-y
            min-width="290px">
            <template v-slot:activator="{ }">
              <v-text-field class="ml-2 mr-2"
              v-model="filters.AgreementsearchText"
              append-icon="mdi-magnify"
              :label="$t('Agreement')"
              solo
              hide-details
              shrink
            ></v-text-field>
            </template>
          </v-menu>
          <v-menu
            ref="menuTo"
            v-model="menuTo"
            :return-value.sync="filters.DateTo"
            transition="scale-transition"
            offset-y
            min-width="290px">
            <template v-slot:activator="{  }">
              <v-text-field class="ml-2 mr-2"
              v-model="filters.DeliverysearchText"
              append-icon="mdi-magnify"
              :label="$t('Delivery')"
              solo
              hide-details
              shrink
            ></v-text-field>
            </template>
          </v-menu>
          <v-flex grow></v-flex>
          <v-flex grow></v-flex>
          <v-flex shrink>
            <v-layout row wrap>
            <v-btn class="ml-3 mt-2 mr-3" :loading="loading" color="primary" @click="refresh"><v-icon>search</v-icon>{{$t('Search')}}</v-btn>
            <v-btn v-if="showButton" class="ml-3 mt-2 mr-3" :loading="loading" :to="{name: 'workplace-edit', params: {id: null, facility: facilityNo, facilityD: facilityDisplay}}" color="primary" @click="refresh">{{$t('Create New')}}</v-btn>
          </v-layout>
            <v-layout>
              <v-checkbox class="ml-2 mr-2" :label="$t('Show deactivated deliveries')" v-model="showDeactivatedDeliveries" :color="'primary'"></v-checkbox>
            </v-layout>
          </v-flex>
      </v-row>
      <v-progress-linear v-if="loading" class="mt-2" :indeterminate="true"></v-progress-linear>
      <v-row v-else v-for="delivery in deliveries" :key="delivery.Id">
        <v-col cols="12">
          <v-card>
              <v-flex xs12 class="mb-4">
                <Delivery :delivery="delivery"></Delivery>
                <v-layout row wrap>
                  <v-flex grow></v-flex>
                  <v-checkbox class="mr-6" :label="$t('Deactivated')" v-model="delivery.DeActive" @click=preDeactivateDelivery(delivery) :color="'primary'"></v-checkbox>
                </v-layout>
              </v-flex>
            <v-divider></v-divider>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog
          v-model="areYouSureDeactivateDialog" max-width="400" persistent>
        <v-card>
          <v-card-title class="headline">{{$t("Deactivate")}}?</v-card-title>
          <template>
            <v-card-text class="font-weight-bold">{{$t("Do you want to deactivate this delivery?")}}</v-card-text>
          </template>
          <v-card-actions>
            <v-spacer></v-spacer>
              <template>
                <v-btn ref="yesButton" color="success" @click="areYouSureDeactivateDialog = false; deactivateDelivery()">{{$t("Yes")}}</v-btn>
                <v-btn ref="noButton" color="primary" @click="areYouSureDeactivateDialog = false" autofocus>{{$t("No")}}</v-btn>
              </template>
            </v-card-actions>
        </v-card>
    </v-dialog>

    </v-container>
  </v-main>
</template>

<script>
import Delivery from '@/modules/workplaces/components/Delivery'
import * as LocalStorage from '@/core/local-storage'
import { loadFacilities } from '@/core/archive'
// import { loadDeliveries } from '@/modules/workplaces/workplaces'
// import { reActivateDelivery } from '@/modules/workplaces/workplaces'
import * as WorkPlaces from '@/modules/workplaces/workplaces'
import * as Security from '@/core/security'
import _ from 'lodash' // clone

export default {
  components: {
    Delivery
  },
  data () {
    return {
      menuFrom: false,
      menuTo: false,
      filters: {
        DeliverysearchText: '',
        AgreementsearchText: ''
      },
      loading: false,
      deliveries: [],
      facilityNo: null,
      facilities: null,
      facilitiesDescription: [],
      facilityDescription: '',
      useFacilityDescription: false,
      facilityDisplay: '',
      facilitiesDisplay: [],
      isVehicleUser: true,
      userName: '',
      customer: '',
      allAgreements: '',
      showButton: false,
      showDeactivatedDeliveries: false,
      areYouSureDeactivateDialog: false
    }
  },
  methods: {
    async refresh () {
      this.loadWorkplaceDeliveries()
    },
    preDeactivateDelivery (delivery) {
      this.markedDelivery = delivery
      this.areYouSureDeactivateDialog = true
    },
    async deactivateDelivery () {
      const deActive = this.markedDelivery.DeActive
      const res = await WorkPlaces.reActivateDelivery(this.markedDelivery, deActive)
      if (!res.failed) {
        await this.refresh()
      }
    },
    async loadWorkplaceDeliveries () {
      this.loading = true
      this.deliveries = []
      if (this.customer !== '') {
        this.filters.AgreementsearchText = this.customer
      }

      const params = { facility: this.facilityNo, workplaceSearch: this.filters.DeliverysearchText, customerSearch: this.filters.AgreementsearchText, showDeactivatedDeliveries: this.showDeactivatedDeliveries }
      const deliveriesRes = await WorkPlaces.loadDeliveries(params)
      // Fix: deliveriesRes.failed does not exist and will result in error on Safari 12.5.2 browser
      if (deliveriesRes && deliveriesRes.length) {
        // Add all VehiclesNum to deliveries
        if (!this.isVehicleUser) {
          // Fix: .Data1.replaceAll() will result in error on Safari 12.5.2 browser. We use .split('x').join('') instead
          this.deliveries = deliveriesRes.map(obj => ({ ...obj, VehiclesNum: obj.Details.find(o => o.Name === 'ValidVehicles')?.Data1.split('[').join('').split(']').join('').split(',') ?? [] }))
        } else {
          const vehicleNum = this.userName.split('.', 2)[1] // Always "SVS.AA00001" etc.
          this.deliveries = deliveriesRes.map(obj => ({ ...obj, VehiclesNum: obj.Details.find(o => o.Name === 'ValidVehicles')?.Data1.includes(vehicleNum) ? [vehicleNum] : [] }))
          if (!this.showDeactivatedDeliveries) {
            this.deliveries = this.deliveries.filter(d => d.DeleteDate !== null)
          }
        }
      }

      if (this.showDeactivatedDeliveries) {
        for (let i = 0; i < this.deliveries.length; i++) {
          var deative = false
          if (this.deliveries[i].DeletedDate !== null && this.deliveries[i].DeletedDate !== undefined) {
            deative = true
          }

          this.deliveries[i].DeActive = deative
        }
      }

      this.loading = false
    },

    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
        if (facilityDisplay != null) {
          this.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.facilityNo = this.facilityDisplay
      }

      if (this.facilityNo != null) {
        LocalStorage.save('facilityNo', this.facilityNo)
      }
      this.loadWorkplaceDeliveries()
    }

  },
  async mounted () {
    this.customer = Security.user.userDetails.find(d => d.Name === 'CustomerNo')?.Value
    this.allAgreements = Security.user.userDetails.find(d => d.Name === 'CreateDeliveriesAllAgreements')?.Value
    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    if (this.customer || this.allAgreements === 'true') {
      this.showButton = true
    }
    const facilitiesRes = await loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
      this.facilitiesDisplay = this.facilities
      if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
        var d = facilitiesResDescription.data
        if (!d.includes('')) d.unshift({ No: '', Description: '' })
        this.facilitiesDescription = d.map(item => {
          return {
            text: item.Description,
            value: item.Description,
            item: item
          }
        })

        this.facilitiesDisplay = this.facilitiesDescription
      }
    }

    const storedFacilityNo = '' + LocalStorage.load('facilityNo')
    if (storedFacilityNo && this.facilities.some(e => e.item.No === storedFacilityNo)) {
      this.facilityNo = storedFacilityNo
      this.facilityDisplay = this.facilityNo
    } else {
      this.facilityNo = null
      LocalStorage.remove('facilityNo')
    }

    if (this.useFacilityDescription) {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } else {
      if (this.facilityNo == null) { this.facilityNo = '' }
      this.facilityDisplay = this.facilities.find(f => f.item.No === this.facilityNo).value
    }
  }
}
</script>
